export default __webpack_public_path__ + "static/media/HistogramChallenge.28efc722.md";